import { createSlice } from '@reduxjs/toolkit'
import { MerchantStatus } from 'api/schemas'
import {
  CheckingPayload,
  ErrorPayload,
  FieldAndValue,
  FieldName,
  MerchantState,
  MerchantValues,
} from './types'
import validators from './validators'

const initialState: MerchantState = {
  values: {
    status: MerchantStatus.Active,
    name: '',
    website: '',
    country: null,
    deliveryTime: null,
    deliveryTerms: '',
    parsingEnabled: true,
    isPricePerBottleSite: false,
    wineSiteType: null,
    isWineEShop: true,
    isMultiCountry: false,
    isMultiCurrency: false,
    vatBehaviorIds: [],
    deliveryCountryIds: [],
    localeIds: [],
    canonicalLocaleId: null,
    currencyIds: [],
    deliveryExport: false,
  },
  errors: {},
  checking: {},
}

const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    setValue(state, { payload }: { payload: FieldAndValue }) {
      const { field, value } = payload
      if (field === 'isWineEShop' && value === false) {
        state.values['isMultiCountry'] = false
        state.values['isMultiCurrency'] = false
      }
      // @ts-ignore
      state.values[field] = value
    },

    setError(state, { payload }: { payload: ErrorPayload }) {
      const { field, value } = payload
      state.errors[field] = value
    },

    setChecking(state, { payload }: { payload: CheckingPayload }) {
      const { field, value } = payload
      state.checking[field] = value
    },

    reset(state) {
      state.values = initialState.values
      state.errors = initialState.errors
      state.checking = initialState.checking
    },

    validateField(state, { payload }: { payload: FieldName }) {
      state.errors[payload] = validators[payload]?.(state.values)
    },

    validateForm(state) {
      const values = state.values

      const errors = Object.keys(validators).map(field => {
        return [field, validators[field](values)]
      })

      state.errors = Object.fromEntries(errors)
    },

    initForm(state, { payload }: { payload: MerchantValues }) {
      state.values = {
        ...initialState.values,
        ...payload,
        isWineEShop: payload?.isWineEShop ?? false,
        isMultiCountry: payload?.isMultiCountry ?? false,
        isMultiCurrency: payload?.isMultiCurrency ?? false,
      }
      state.errors = initialState.errors
      state.checking = initialState.checking
    },
  },
})

export const { actions, reducer: merchant } = merchantSlice
export const {
  setValue,
  setError,
  setChecking,
  reset,
  validateField,
  validateForm,
  initForm,
} = actions
